import { useState } from 'react';
import { CustomTable, Column } from 'components/CustomTable';
import { Row } from 'components/Row';

interface Props {
  columns: Column[];
  columnsMobile: Column[];
  rows: object[];
  defaultVisibleRowCount?: number;
}

export const TableSection = ({
  columns,
  columnsMobile,
  rows,
  defaultVisibleRowCount = 4,
}: Props) => {
  const [visibleRowCount, setVisibleRowCount] = useState(defaultVisibleRowCount);

  if (!Array.isArray(rows)) {
    throw new Error('TableSection expected rows to be an array');
  }

  const onShowMoreClick = () => {
    setVisibleRowCount(rowCount => rowCount + 10);
  };

  const onShowLessClick = () => {
    setVisibleRowCount(defaultVisibleRowCount);
  };

  return (
    <>
      <CustomTable hideForSmall={true} columns={columns} data={rows.slice(0, visibleRowCount)} />
      <CustomTable
        hideForLarge={true}
        columns={columnsMobile}
        data={rows.slice(0, visibleRowCount)}
      />
      <Row style={{ gap: '8px' }}>
        {rows.length && visibleRowCount < rows.length && (
          <button
            type="button"
            className="donation-history-show-more-btn"
            onClick={onShowMoreClick}
          >
            Show more
          </button>
        )}
        {rows.length && visibleRowCount > defaultVisibleRowCount && (
          <button
            type="button"
            className="donation-history-show-more-btn"
            onClick={onShowLessClick}
          >
            Show less
          </button>
        )}
      </Row>
    </>
  );
};
